<template>
    <div class="table-skeleton" :class="{ 'table-skeleton--dense': dense }">
        <div class="table-skeleton__table">
            <div class="table-skeleton__head">
                <div class="table-skeleton__row table-skeleton__row--head">
                    <div
                        v-if="showSelect"
                        class="table-skeleton__cell table-skeleton__cell--checkbox"
                    >
                        <div class="table-skeleton__line table-skeleton__line--checkbox" />
                    </div>
                    <div
                        v-for="(col, idx) in columnCount"
                        :key="'head-' + col"
                        class="table-skeleton__cell"
                    >
                        <span
                            v-if="headerLabels && headerLabels[idx]"
                            class="table-skeleton__header-text"
                        >{{ headerLabels[idx] }}</span>
                        <div v-else class="table-skeleton__line table-skeleton__line--header" />
                    </div>
                </div>
            </div>
            <div class="table-skeleton__body">
                <div
                    v-for="row in rowCount"
                    :key="'row-' + row"
                    class="table-skeleton__row"
                >
                    <div
                        v-if="showSelect"
                        class="table-skeleton__cell table-skeleton__cell--checkbox"
                    >
                        <div
                            class="table-skeleton__line table-skeleton__line--checkbox"
                        />
                    </div>
                    <div
                        v-for="col in columnCount"
                        :key="'cell-' + row + '-' + col"
                        class="table-skeleton__cell"
                    >
                        <div
                            class="table-skeleton__line"
                            :style="{
                                width: cellWidths[(row + col) % cellWidths.length],
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showFooter" class="table-skeleton__footer">
            <div class="table-skeleton__line table-skeleton__line--footer" />
        </div>
    </div>
</template>

<script>
export default {
    name: "TableSkeleton",
    props: {
        columnCount: {
            type: Number,
            default: 4,
        },
        rowCount: {
            type: Number,
            default: 5,
        },
        showSelect: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        showFooter: {
            type: Boolean,
            default: true,
        },
        headerLabels: {
            type: Array,
            default: null,
        },
    },
    computed: {
        cellWidths() {
            return ["55%", "70%", "45%", "60%", "80%"];
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.table-skeleton {
    width: 100%;
    overflow: hidden;
}

.table-skeleton__table {
    width: 100%;
    border-top: thin solid rgba(0, 0, 0, 0.12);
}

.table-skeleton__row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 0 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    min-height: 52px;
}

.table-skeleton--dense .table-skeleton__row {
    min-height: 40px;
}

.table-skeleton__row--head {
    min-height: 48px;
}

.table-skeleton--dense .table-skeleton__row--head {
    min-height: 32px;
}

.table-skeleton__row--head .table-skeleton__cell {
    padding: 0;
}

.table-skeleton__cell {
    flex: 1 1 0;
    min-width: 0;
    padding: 12px 0;
}

.table-skeleton__cell--checkbox {
    flex: 0 0 48px;
    max-width: 48px;
}

.table-skeleton__line {
    height: 14px;
    border-radius: 4px;
    background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.06) 25%,
        rgba(0, 0, 0, 0.1) 50%,
        rgba(0, 0, 0, 0.06) 75%
    );
    background-size: 200% 100%;
    animation: table-skeleton-shimmer 1.5s ease-in-out infinite;
}

.table-skeleton__line--header {
    height: 12px;
    width: 65%;
}

.table-skeleton__header-text {
    font-size: $data-table-regular-header-font-size;
    font-weight: 600;
    color: $color-gs-black;
    font-family: "Inter", sans-serif;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
}

.table-skeleton__line--checkbox {
    width: 18px;
    height: 18px;
    border-radius: 2px;
}

.table-skeleton__line--footer {
    width: 220px;
    height: 12px;
}

.table-skeleton__footer {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    border-top: thin solid rgba(0, 0, 0, 0.12);
}

@keyframes table-skeleton-shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
